import { __decorate } from "tslib";
import { Directive, ViewContainerRef } from "@angular/core";
let PropertiesAdvancedSearchHostDirective = class PropertiesAdvancedSearchHostDirective {
    viewContainerRef;
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    static ctorParameters = () => [
        { type: ViewContainerRef }
    ];
};
PropertiesAdvancedSearchHostDirective = __decorate([
    Directive({
        standalone: false,
        selector: "[appPropertiesAdvancedSearchHost]"
    })
], PropertiesAdvancedSearchHostDirective);
export { PropertiesAdvancedSearchHostDirective };
